import type { InviteEmailDelivery } from './types';

/** O link que o convidado abre. O segredo só existe no 201 — daí a tela mostrar e pedir para copiar. */
export function buildInviteLink(origin: string, acceptSecret: string): string {
  return `${origin.replace(/\/+$/, '')}/convite/${encodeURIComponent(acceptSecret)}`;
}

/** Texto honesto sobre o e-mail: o convite existe de qualquer jeito; o que muda é quem entrega o link. */
export function emailDeliveryCopy(d: InviteEmailDelivery, email: string): string {
  switch (d.status) {
    case 'sent':
      return `E-mail enviado para ${email}. Se preferir, copie o link e mande por outro canal.`;
    case 'failed':
      return `O e-mail não saiu (${d.reason ?? 'falha no envio'}). Copie o link e envie você mesmo.`;
    case 'skipped':
    default:
      return `E-mail automático desligado neste ambiente${d.reason !== undefined ? ` (${d.reason})` : ''}. Copie o link e envie para ${email}.`;
  }
}

/** Link de redefinição de senha (Item 477) — mesmo padrão do convite. */
export function buildResetLink(origin: string, resetSecret: string): string {
  return `${origin.replace(/\/+$/, '')}/redefinir-senha/${encodeURIComponent(resetSecret)}`;
}
